import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSteamworksComponent } from './simple-icons-steamworks.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSteamworksComponent ],
    exports:      [ SimpleIconsSteamworksComponent ],
    bootstrap:    []
})
export class SimpleIconsSteamworksModule {}
